import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-56" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl rounded-2xl border-2 border-brand/20 bg-brand-soft p-6 text-center sm:p-10" data-id="element-57" data-mp="4x31fpyzl7ea">
        <ShieldCheckIcon className="mx-auto h-12 w-12 text-brand" aria-hidden="true" data-id="element-58" data-mp="et67v80vfs71" />
        <h2 className="mt-4 font-display text-xl font-extrabold uppercase tracking-wide text-brand-deep sm:text-2xl" data-id="element-59" data-mp="jtc1uuum5qsa">
          Garantía de satisfacción
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gray-700 sm:text-lg" data-id="element-60" data-mp="skug30801wiq">
          Tienes <strong className="font-semibold" data-id="element-61" data-mp="smxdi5bherxh">7 días</strong> para revisar
          el método, explorar los tomos y comenzar tu reinicio. Si sientes que
          el contenido no es para ti, puedes solicitar la devolución del 100% de
          tu dinero. Sin preguntas complicadas.
        </p>
        <p className="mt-4 text-sm text-gray-500" data-id="element-62" data-mp="17g0mvpex5zd4">
          Queremos que entres con tranquilidad y pruebes el protocolo sin
          riesgo.
        </p>
      </div>
    </section>;
}